import React, { useContext } from "react";
import { CircleNotch } from "phosphor-react";
import { MapContext } from "context/map";
import "./index.scss";

const RasterLoading = () => {
  const { state } = useContext(MapContext);
  const { rasterLoading } = state;

  if (!rasterLoading) return null;

  return (
    <div className="loading">
      <CircleNotch size={64} color="#09ba51" />
    </div>
  );
};

export default RasterLoading;
